import React, { createContext, useState, useContext, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { THEME_TYPES } from './index';
import darkTheme from './darkTheme';
import lightTheme from './lightTheme';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children, initialTheme = THEME_TYPES.DARK }) => {
  const [themeType, setThemeType] = useState(initialTheme);

  const theme = useMemo(() => {
    return themeType === THEME_TYPES.DARK ? darkTheme : lightTheme;
  }, [themeType]);

  const toggleTheme = () => {
    setThemeType(current => 
      current === THEME_TYPES.LIGHT ? THEME_TYPES.DARK : THEME_TYPES.LIGHT
    );
  };

  const value = {
    themeType,
    setThemeType,
    toggleTheme,
    theme,
  };

  return (
    <ThemeContext.Provider value={value}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};